export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body?.appendChild(link)
  try {
    link.click()
  } finally {
    link.remove?.()
    URL.revokeObjectURL(url)
  }
}

export function downloadText(filename: string, mimeType: string, content: string) {
  downloadBlob(new Blob([content], { type: mimeType }), filename)
}
